// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1587c2fb","slideWrapper":"_c44f098c","image":"_77958b4f","right":"_8964a5a8","left":"_7e63c153","imageWrapper":"_f24d6c9c","slideTitle":"_8c522bbf"};